"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reward = exports.GiveawayRewards = void 0;
const Slider_1 = __importDefault(require("root/src/client/web/base/Slider"));
const identity_1 = __importDefault(require("ramda/src/identity"));
const dropKeys_1 = require("root/src/shared/constants/dropKeys");
const RewardCard = __importStar(require("root/src/client/web/giveaway/components/RewardCard"));
const useGiveawayRewards_1 = require("root/src/client/web/giveaway/features/GiveawayRewards/hooks/useGiveawayRewards");
const classnames_1 = __importDefault(require("classnames"));
const GiveawayRewards = () => {
    const { rewards, sliderBreakpoints, classes } = (0, useGiveawayRewards_1.useGiveawayRewards)();
    // means user has no rewards available
    if (!(rewards === null || rewards === void 0 ? void 0 : rewards.length))
        return null;
    return (<div className="flex flex-col gap-5">
			<span className="uppercase text-xs text-light-4 mx-4">Reward giveaway options</span>
			{/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
			{/* @ts-ignore */}
			<Slider_1.default containerClassName="gap-8 flex" arrows renderItems={() => identity_1.default} renderSliderItem={() => identity_1.default} showItems={sliderBreakpoints} infinite arrowsPadding={30} sliderItemsStyle={classes.sliderItems}>
				{rewards.map(reward => (<Reward reward={reward}/>))}
			</Slider_1.default>
		</div>);
};
exports.GiveawayRewards = GiveawayRewards;
function Reward({ reward }) {
    const region = 'region' in reward ? `(${reward.region})` : '';
    return (<RewardCard.Root className={(0, classnames_1.default)('flex-1 border', reward.isClaimed ? 'border-gray-1' : 'border-teal')} key={reward.id}>
			{(reward.isClaimed) && (<RewardCard.ClaimedLabel />)}
			<RewardCard.ImageContainer className={(0, classnames_1.default)(reward.isClaimed ? 'border-gray-1' : '')}>
				<RewardCard.GameImage src={reward.image} alt={reward.name}/>
			</RewardCard.ImageContainer>
			<RewardCard.GameTitle>{reward.name}</RewardCard.GameTitle>
			<RewardCard.Details>
				<RewardCard.RewardTitle className={(0, classnames_1.default)(reward.isClaimed ? 'text-gray-1' : '')}>
					{reward.name} code {region}
				</RewardCard.RewardTitle>
				{typeof reward.platform === 'string' && <RewardCard.PlatformIcon icon={dropKeys_1.platformIconMap[reward.platform]}/>}
				{reward.restrictions && (<RewardCard.RewardRestrictions>
						{reward.restrictions}
					</RewardCard.RewardRestrictions>)}
			</RewardCard.Details>
		</RewardCard.Root>);
}
exports.Reward = Reward;
